function triggerEdapEvent(eventName = '', eventData = {}, options = {}) {
    if (typeof window === 'undefined') {
        return;
    }

    window.edap.push((edapInstance) => {
        edapInstance.trigger(eventName, eventData, options);
    });
}

function triggerEdapPageView() {
    if (typeof window === 'undefined') {
        return;
    }

    window.analyticsdatalayer.pagename = window.location.pathname;

    window.edap.push((edapInstance) => {
        edapInstance.trigger('pageview');
    });
}

export {triggerEdapPageView, triggerEdapEvent};
